/** @jsx jsx */
import { jsx } from 'theme-ui'

import { number, string } from 'prop-types'

const Open = ({ color, height = 20 }) => {
  return (
    <svg width={20} height={height} viewBox="0 0 20 20" sx={{ fill: color }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0v2h4.475L9.066 9.165l1.47 1.292L18 2.926V8h2V0h-8zm6 12h2v8H0V0h8v2H2v16h16v-6z"
      />
    </svg>
  )
}

Open.propTypes = {
  height: number,
  color: string,
}

export default Open
